<template>
  <div>
    <div class="mx-auto mt-16 pt-2" :class="isMobile ? 'w-full px-2' : 'section'">
      <button class="w-20 px-3 mb-2 font-bold border-2 rounded-md bg-white cursor-pointer" @click="back()">
        ＜戻る
      </button>
      <div class="w-full base-color min-h-10">
        <div v-if="type === 'before'" class="float-left ml-2 bg-blue-600 text-white my-2 px-4 rounded-full">
          <span v-if="mode === 'fare'">
            改定前運賃
          </span>
          <span v-else>
            改定前定期運賃
          </span>
        </div>
        <div v-else class="float-left ml-2 bg-red-600 text-white my-2 px-4 rounded-full">
          <span v-if="mode === 'fare'">
            改定後運賃
          </span>
          <span v-else>
            改定後定期運賃
          </span>
        </div>
        <div v-for="(s, index) in viaList" v-bind:key="index" class="float-left font-bold my-2 text-white">
          <div v-if="index > 0" class="float-left ml-2">
            →
          </div>
          <div class="float-left ml-2">
            {{ s }}
          </div>
        </div>
        <div class="clear-both"></div>
      </div>
      <div class="text-center mx-auto mt-2">
        <div id="result" ref="result">
        </div>
      </div>
      <div v-if="errors" class="font-bold text-red-500">
        <div class="ml-6">
          <div v-for="(error, index) in errors" :key="index" type="1" v-html="error"></div>
        </div>
      </div>
      <div class="text-center mb-2 font-bold text-blue-600 underline break-all cursor-pointer" @click="back()">
        ←戻る
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Constants from '@/constants';

export default {
  data() {
    return {
      result: null,
      answerCount: 5,
      errors: null,
    }
  },
  computed: mapGetters({
    viaList: 'getViaList',
    mode: 'getMode',
    type: 'getType',
    teikiKind: 'getTeikiKind',
    isMobile: 'getIsMobile',
  }),
  async mounted() {
    this.result = new window.expGuiCourse(this.$refs.result);
    this.result.setConfigure("apiURL", Constants.API_BASE_URL);
    this.result.setConfigure("CourseDisplay", 'all');
    this.result.setConfigure("PriceChange", true);
    this.result.setConfigure("PriceChangeRefresh", true);
    if (this.isMobile) {
      this.result.setConfigure("agent", 2);
    } else {
      this.result.setConfigure("agent", 1);
    }

    const date = this.type === 'before' ? '20260302' : '20260316';
    this.$store.commit('setIsLoading', true);
    try {
      const response = await this.request('get', Constants.API_BASE_URL + 'v1/json/search/course/extreme?viaList=' + this.viaList.join(':') + '&date=' + date + '&teikiKind=' + this.teikiKind + '&mode=' + this.mode);
      const result = response.data;
      if (result.ResultSet.Course) {
        this.result.setResult(result, this.mode === 'teiki' ? this.result.PRICE_TEIKI : undefined);
      } else {
        if (this.mode === 'teiki') {
          this.errors = [
            'ご入力の経路が見つかりませんでした。',
            '下記をご確認ください。',
            '1.定期券が発行できない区間が含まれている',
            '2.最初の区間がJR以外になっている',
          ];
        } else {
          this.errors = [
            'ご入力の経路が見つかりませんでした。',
            '下記をご確認ください。',
            '1.最初の区間がJR以外になっている',
          ];
        }
      }
    } catch (response) {
      console.log(response);
    } finally {
      this.$store.commit('setIsLoading', false);
    }
  },
  methods: {
    back: function () {
      this.$router.push({ name: 'TopPage', query: { viaList: this.viaList.join(':'), mode: this.mode, type: this.type, teikiKind: this.teikiKind } });
    },
  }
}
</script>

<style scoped>
.section {
  width: 44rem;
}
</style>
